import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { SEOHead } from "@/components/SEO/SEOHead";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30">
      <SEOHead
        title="Sidan hittades inte (404) | Affärsnätverket"
        description="Sidan du söker finns inte. Gå tillbaka till startsidan för att hitta rätt."
        noindex
      />
      <div className="text-center max-w-lg px-4">
        <h1 className="mb-4 text-4xl font-bold text-foreground">404</h1>
        <p className="mb-6 text-xl text-muted-foreground">Sidan kunde inte hittas</p>
        <p className="mb-8 text-muted-foreground">
          Sidan du letar efter kan ha flyttats eller tagits bort. Här hittar du det du söker:
        </p>
        <nav className="flex flex-col gap-3 mb-8 text-left max-w-xs mx-auto">
          <Link to="/" className="text-primary underline hover:text-primary/80">
            → Startsidan
          </Link>
          <Link to="/news" className="text-primary underline hover:text-primary/80">
            → Nyheter
          </Link>
          <Link to="/partners" className="text-primary underline hover:text-primary/80">
            → Samarbetspartners
          </Link>
          <Link to="/foretagsnatverk" className="text-primary underline hover:text-primary/80">
            → Nätverksträffar
          </Link>
        </nav>
      </div>
    </div>
  );
};

export default NotFound;
